import { token } from '../../localStorage'
import { BASE_URL } from '../constants'

export const uploadVideo = async (data, id) => {
  const URL = `${BASE_URL}hutritNext/video/upload`

  const formData = new FormData()

  formData.append('video', data)
  formData.append('videoId', id)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        authorization: token?.token,
      },
      body: formData,
    })

    const responseTwo = await response.json()

    return { response, responseTwo }
  } catch (error) {
    console.log(error)
  }
}

export const uploadDescription = async (data) => {
  const URL = `${BASE_URL}hutritNext/video/uploadDescription`

  const rawBody = JSON.stringify(data)

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    const responseTwo = await response.json()

    return { response, responseTwo }
  } catch (error) {
    console.log(error)
  }
}

export const listOfVideoTalentsFromMaster = ({
  page = 0,
  visible = false,
  rejected = false,
}) => {
  const URL = `${BASE_URL}master/hutritNext/list/video?visible=${
    visible ?? false
  }&rejected=${rejected ?? false}&page=${page}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const listOfPublicVideoTalents = ({ page = 0 }) => {
  const URL = `${BASE_URL}/public/hutritNext/list/video?page=${page ?? 0}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const updateTalentStatusHutritClub = async (data) => {
  const URL = `${BASE_URL}master/hutritNext/setStateVideo`

  const rawBody = JSON.stringify(data)

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const createChallenge = async (data) => {
  const URL = `${BASE_URL}hutritNext/create/challenges`

  const rawBody = JSON.stringify(data)

  try {
    const res = await fetch(URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
      body: rawBody,
    })
    return res
  } catch (error) {
    console.log(error)
  }
}

export const listOfChallenges = ({ page = 0 }) => {
  const URL = `${BASE_URL}hutritNext/list/challenges/company?page=${page}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const listOfGeneralChallenges = () => {
  const URL = `${BASE_URL}/hutritNext/list/challengesNames`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}

export const challengeDetail = ({ id }) => {
  const URL = `${BASE_URL}hutritNext/get/challenge?id=${id}`

  try {
    const response = fetch(URL, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        authorization: token?.token,
      },
    })
      .then((response) => response.json())
      .then((res) => res || [])

    return response
  } catch (error) {
    console.log(error)
  }
}
